"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDetailVideos = exports.defaultDetailVideo2 = exports.defaultDetailVideo = void 0;
exports.defaultDetailVideo = {
    src: '437812880',
    title: 'video 1',
    caption: 'this is testing video 1',
    thumb: 'https://images.okay.com/DiscoveryBay/DevelopmentThumbnails/Amalfi_1.jpg',
};
exports.defaultDetailVideo2 = {
    src: '437812390',
    title: 'video 2',
    caption: 'this is testing video 2',
    thumb: 'https://images.okay.com/DiscoveryBay/DevelopmentThumbnails/Amalfi_1.jpg',
};
exports.defaultDetailVideos = [
    exports.defaultDetailVideo,
    exports.defaultDetailVideo2,
];
